export const INIT_PROFILE = 'INIT_PROFILE';
export const INIT_PROFILE_RESULTS = 'INIT_PROFILE_RESULTS';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_FULFILLED = 'GET_PROFILE_FULFILLED';
export const GET_PROFILE_REJECTED = 'GET_PROFILE_REJECTED';
export const GET_PROFILE_RESULT_FROM_REPORT_FULFILLED = 'GET_PROFILE_RESULT_FROM_REPORT_FULFILLED';
export const GET_PROFILE_REPORT_NOTES_FULFILLED = 'GET_PROFILE_REPORT_NOTES_FULFILLED';
export const GET_PROFILE_HISTORY_FULFILLED = 'GET_PROFILE_HISTORY_FULFILLED';
